import React from "react"
import { useDroppable } from "@dnd-kit/core"
import { Box, Text, useColorModeValue } from "@chakra-ui/react"

export interface DashboardChartRowInsertDropZoneProps {
  id: string
  isDragActive: boolean
}

export function DashboardChartRowInsertDropZone({
  id,
  isDragActive,
}: DashboardChartRowInsertDropZoneProps): React.ReactElement | null {
  const { setNodeRef, isOver } = useDroppable({ id })
  const defaultBorderColor = "#D3D3D3"
  const activeBorderColor = useColorModeValue("#38BBD1", "#38BBD1")
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.50")

  if (!isDragActive) return null

  return (
    <Box
      ref={setNodeRef}
      w="100%"
      minH={isOver ? "72px" : "48px"}
      my="12px"
      border="2px dashed"
      borderColor={isOver ? activeBorderColor : defaultBorderColor}
      borderRadius="6px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={isOver ? hoverBg : "transparent"}
      transition="min-height 0.15s ease, border-color 0.15s ease, background-color 0.15s ease"
      pointerEvents="auto"
    >
      <Text
        fontSize="sm"
        color={isOver ? activeBorderColor : defaultBorderColor}
        fontWeight="medium"
        fontFamily="'IBM Plex Sans', sans-serif"
        textTransform="uppercase"
        opacity={isOver ? 1 : 0.6}
      >
        Drop here
      </Text>
    </Box>
  )
}
